import SelectField from "../common/SelectField";
import SearchBar from "../common/SearchBar";
import "../../styles/common.css";
import "../../styles/driverHeader.css";
import "../../styles/driver_modal.css";
import { Plus, UserCheck, Radio, Users } from "lucide-react";

export default function DriverHeader({ 
  total, search, onSearch, onAdd, 
  approveFilter, onApproveChange, 
  availFilter, onAvailChange 
}) {
  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <div className="titleWithIcon">
            <Users size={24} className="primaryIcon" />
            <h2>Chauffeurs</h2>
          </div>
          <span className="countBadge">{total} chauffeurs</span>
        </div>
        
        <button className="btnPrimary" onClick={onAdd}>
          Ajouter un chauffeur
          <Plus size={18} style={{ marginLeft: '8px' }} />
        </button>
      </div>

      <div className="filterActionsRow">
        <div className="selectorsGrid">
          <SelectField
            icon={UserCheck}
            value={approveFilter}
            onChange={onApproveChange}
            options={[
                { label: "Tous les comptes", value: "all" },
                { label: "Approuvés", value: "approved" },
                { label: "En attente", value: "pending" },
            ]}
          />
          <SelectField
            icon={Radio}
            value={availFilter}
            onChange={onAvailChange}
            options={[
                { label: "Tous les états", value: "all" },
                { label: "En ligne", value: "available" },
                { label: "Hors ligne", value: "unavailable" },
            ]}
          />
        </div>
            
        <div className="searchWrapper">
          <SearchBar
            value={search}
            onChange={onSearch}
            placeholder="Rechercher nom, tel, user..."
          />
        </div>
      </div>
    </div>
  );
}